module.exports = __webpack_public_path__ + "img/9d67655feeb625c562b061e8cf525427.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_logo10.png
// module id = 918
// module chunks = 5